import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Modal as SemanticModal } from 'semantic-ui-react';
import CloseOverlayButton from '../CloseOverlayButton';
import { useFullscreenContext } from '../../utils/contexts/FullscreenContext';
import {
  FloatingLayerProvider,
  getFloatingHostElement,
} from '../FloatingManager';

interface IProps {
  children: ReactNode;
}

export const FullScreenModal = styled(SemanticModal)`
  &&&&& {
    width: calc(100vw - 10rem);
    margin: 0;
  }
`;

export const FullScreenModalContent = styled(SemanticModal.Content)`
  &&&&& {
    max-height: unset;
    height: calc(100vh - 8rem);
  }
`;

export const FullScreenModalCloseAction = styled(CloseOverlayButton)`
  position: absolute;
  top: 0;
  right: -40px;
`;

export const FullscreenContainer = ({ children }: IProps) => {
  const { isFullScreen, toggleFullScreen } = useFullscreenContext();

  if (isFullScreen) {
    return (
      <FullScreenModal
        open={true}
        onClose={toggleFullScreen}
        mountNode={getFloatingHostElement()}
      >
        <FullScreenModalCloseAction onClick={toggleFullScreen} />
        <FullScreenModalContent scrolling>
          <FloatingLayerProvider>{children}</FloatingLayerProvider>
        </FullScreenModalContent>
      </FullScreenModal>
    );
  }

  return <>{children}</>;
};
